import { ActivityKey } from "../shared/models/ActivityKey"

export type GameState = TransitionState | ActivityKey

export enum TransitionState {
    MAP = "MAP",
    WORLD = "WORLD",

    /////////////////
    // Transitions //
    /////////////////

    /////
    // Grade 5, Lesson 1
    /////

    ECIG_101_INTRO = "ECIG_101-intro",
    ECIG_101_EXIT = "ECIG_101-outro",

    TOUR_INTRO = "TOUR-intro",
    TOBACCO_TOUR_CHEW = "TOBACCO_TOUR_CHEW",
    TOBACCO_TOUR_CIG = "TOBACCO_TOUR_CIG",
    ECIG_TOUR = "ECIG_TOUR",
    TOBACCO_TOUR_REVIEW = "TOBACCO_TOUR_REVIEW",
    TOUR_EXIT = "TOUR-outro",

    /////
    // Grade 5, Lesson 2
    /////

    KIDS_CHOICE_INTRO = "KIDS_CHOICE-intro",
    KIDS_CHOICE_EXIT = "KIDS_CHOICE-outro",
    KIDS_CHOICE_EXIT2 = "KIDS_CHOICE-outro2",

    MAKE_YOUR_OWN_VAPER_PT_1_INTRO = "MAKE_YOUR_OWN_VAPER_PT_1-intro",
    MAKE_YOUR_OWN_VAPER_PT_1_EXIT = "MAKE_YOUR_OWN_VAPER_PT_1-outro",

    KIDS_CHOICE_2_INTRO = "KIDS_CHOICE_2-intro",
    KIDS_CHOICE_2_EXIT = "KIDS_CHOICE_2-outro",

    REALITY_CHECK_INTRO = "REALITY_CHECK-intro",
    REALITY_CHECK_EXIT = "REALITY_CHECK-outro",

    /////
    // Grade 5, Lesson 3
    /////

    MAKE_YOUR_OWN_VAPER_PT_2 = "MAKE_YOUR_OWN_VAPER_PT_2",

    ADDICTION_101_INTRO = "ADDICTION_101-intro",
    ADDICTION_MENTAL = "ADDICTION_MENTAL",
    ADDICTION_PHYSICAL = "ADDICTION_PHYSICAL",
    ADDICTION_NICOTINE = "ADDICTION_NICOTINE",
    ADDICTION_CRAVINGS_AND_WITHDRAWAL = "ADDICTION_CRAVINGS_AND_WITHDRAWAL",
    ADDICTION_101_EXIT = "ADDICTION_101-outro",

    ADDICTION_PONG_INTRO = "ADDICTION_PONG-intro",
    ADDICTION_PONG_EXIT = "ADDICTION_PONG-outro",
    ADDICTION_PONG_EXIT2 = "ADDICTION_PONG-outro2",

    /////
    // Grade 5, Lesson 4
    /////

    CAMP_CRAVINGS_INTRO = "CAMP_CRAVINGS-intro",
    CAMP_CRAVINGS_EXIT = "CAMP_CRAVINGS-outro",
    CAMP_CRAVINGS_EXIT2 = "CAMP_CRAVINGS-outro2",

    PERSONALITY = "PERSONALITY",

    /////
    // Grade 5, Lesson 5
    /////

    SECOND_HAND_WELCOME = "SECOND_HAND-welcome",
    SECOND_HAND_INTRO = "SECOND_HAND-intro",
    SECOND_VS_DIRECT = "SECOND_VS_DIRECT",
    SHORT_TERM = "SHORT_TERM",
    LONG_TERM = "LONG_TERM",
    EFFECTS_OF_VAPOR = "EFFECTS_OF_VAPOR",
    SECOND_HAND_EXIT = "SECOND_HAND-outro",

    SUPER_HERO_INTRO = "SUPER_HERO-intro",
    SUPER_HERO_CORE = "SUPER_HERO_CORE",
    SUPER_HERO_EXIT = "SUPER_HERO-outro",

    TRUTH_OR_DARE_INTRO = "TRUTH_OR_DARE-intro",
    TRUTH_OR_DARE_EXIT = "TRUTH_OR_DARE-outro",

    /////
    // Grade 5, Lesson 6
    /////

    MAKE_A_VIDEO_INTRO = "MAKE_A_VIDEO-intro",
    MAKE_A_VIDEO_EXIT = "MAKE_A_VIDEO-outro",

    WHEEL_INTRO = "WHEEL_OF_MISFORTUNE-intro",
    WHEEL_EXIT = "WHEEL_OF_MISFORTUNE-outro",
    WHEEL_EXIT2 = "WHEEL_OF_MISFORTUNE-outro2",

    EVERY_CIG_INTRO = "EVERY_CIG-intro",
    EVERY_CIG_EXIT = "EVERY_CIG-outro",

    /////
    // Grade 5, Lesson 7
    /////

    DEFINITION_WELCOME = "DEFINITION-welcome",
    DEFINITION_INTRO = "DEFINITION-intro",
    DEFINITION_EXIT = "DEFINITION-outro",

    MAZE_INTRO = "MAZE-intro",
    MAZE_EXIT = "MAZE-outro",

    EVERY_CIG_2_INTRO = "EVERY_CIG_2-intro",
    EVERY_CIG_2_EXIT = "EVERY_CIG_2-outro",

    /////
    // Grade 5, Lesson 8
    /////

    TIME_MACHINE_WELCOME = "TIME_MACHINE-welcome",
    TIME_MACHINE_INTRO = "TIME_MACHINE-intro",
    TIME_MACHINE_EXIT = "TIME_MACHINE-outro",

    SUMMARY_INTRO = "SUMMARY-intro",
    SUMMARY_OUTRO = "SUMMARY-outro",

    PLAYGROUND_INTRO = "PLAYGROUND-intro",
    PLAYGROUND_EXIT = "PLAYGROUND-outro",

    FIREWORKS = "FIREWORKS",

    /////
    // Grade 6, Lesson 1
    /////

    ECIG_201_INTRO = "ECIG_201-intro",
    ECIG_201_EXIT = "ECIG_201-outro",

    MYSTERY_INTRO = "MYSTERY-intro",
    MYSTERY = "MYSTERY",
    MYSTERY_OUTRO = "MYSTERY-outro",

    DR_TIME_INTRO = "DR_TIME-intro",
    DR_TIME = "DR_TIME",
    DR_TIME_OUTRO = "DR_TIME-outro",

    /////
    // Grade 6, Lesson 2
    /////

    ADDICTION_201_INTRO = "ADDICTION_201-intro",
    ADDICTION_201_EXIT = "ADDICTION_201-outro",

    ADDICTION_ROAD_INTRO = "ADDICTION_ROAD-intro",
    ADDICTION_ROAD = "ADDICTION_ROAD",
    ADDICTION_ROAD_EXIT = "ADDICTION_ROAD-outro",
    ADDICTION_ROAD_EXIT2 = "ADDICTION_ROAD-outro2",

    MAKE_A_FRIEND_INTRO = "MAKE_A_FRIEND-intro",
    MAKE_A_FRIEND = "MAKE_A_FRIEND",
    MAKE_A_FRIEND_OUTRO = "MAKE_A_FRIEND-outro",

    SUMMARY_6_INTRO = "SUMMARY_6-intro",
    SUMMARY_6_OUTRO = "SUMMARY_6-outro",

    FIREWORKS_6 = "FIREWORKS_6"
}
